<template>
	<div>
		<v-carousel
			:continuous="false"
			:show-arrows="false"
			hide-delimiters
			height="auto"
			light
			v-model="step"
		>
			<v-carousel-item>
				<template v-if="features.length">
					<div class="font-weight-bold mb-2">
						Žemėlapio istorijos objektai:
					</div>
					<ul class="pl-2">
						<draggable
							v-model="features"
							group="features"
							@start="drag = true"
							@end="drag = false"
							v-bind="dragOptions"
							v-on:update="setProperIndices"
						>
							<transition-group
								type="transition"
								name="!drag ? 'flip-list' : null"
							>
								<template v-for="(feature, n) in features">
									<li v-bind:key="n" class="d-flex align-center mb-2 my-object-row">
										<MyObjectIcon :feature="feature" :key="n + feature.get('color')" /> <!-- FIXME! Tiksliai nežinau ar gerai formuojamas key'us. Be jo buvo problema nubraižius naują objektą, pakeitus jo spalvą ir grįžus į objektų sąrašą... Neatsinaujindavo simbolio spalva... -->
										<span class="pl-1">{{getFeatureTitle(feature)}}</span>
										<v-btn icon v-on:click="setActiveFeature(feature, true)" class="ml-1" :height="28" :width="28">
											<v-icon title="Redaguoti" size="20">mdi-pencil</v-icon>
										</v-btn>
									</li>
								</template>
							</transition-group>
						</draggable>
					</ul>
				</template>
				<div class="font-weight-bold mb-2">
					<template v-if="features.length">
						<div class="mt-5">Pridėkite žemėlapio istorijos objektą:</div>
					</template>
					<template v-else>
						<div>Pridėkite pirmąjį žemėlapio istorijos objektą:</div>
					</template>
				</div>
				<div>
					Pasirinkite įvedimo įrankį paspaudę mygtuką žemiau, tada pažymėkite objekto vietą žemėlapyje. Atsidariusiame lange įvedę objekto informaciją, nepamirškite jos išsaugoti.”
				</div>
				<div class="mt-2 d-flex align-center">
					<v-btn
						icon
						v-on:click="toggleEditing"
						:class="[editingActive ? 'editing-active' : '']"
					>
						<v-icon title="Aktyvuoti objekto įvedimo įrankį">mdi-pencil-box-outline</v-icon>
					</v-btn>
					<span class="pl-1">Pridėti žemėlapio istorijos objektą</span>
				</div>
			</v-carousel-item>
			<v-carousel-item>
				<template v-if="activeFeature">
					<Back title="Grįžti į žemėlapio istorijos objektų sąrašą" :action="showMainScreen" />
					<div class="mt-5">
						<MyObjectForm
							:feature="activeFeature"
							:key="activeFeature.getId()"
							:onEditsComplete="showMainScreen"
							:removeFeature="removeFeature"
						/>
					</div>
				</template>
			</v-carousel-item>
		</v-carousel>
	</div>
</template>

<script>
	import VectorSource from "ol/source/Vector";
	import VectorLayer from "ol/layer/Vector";
	import Draw from "ol/interaction/Draw";
	import Feature from "ol/Feature";
	import Point from "ol/geom/Point";
	import CommonHelper from "../../../../../components/helpers/CommonHelper";
	import MyObjectIcon from "./components/MyObjectIcon";
	import MyObjectForm from "./components/MyObjectForm";
	import Back from "../../../../../components/Back";
	import draggable from "vuedraggable";
	import Translate from "ol/interaction/Translate";

	export default {
		data: function(){
			var data = {
				features: [],
				step: 0,
				editingActive: false,
				activeFeature: null,
				dragOptions: {
					animation: 200,
					group: "features",
					disabled: false,
					ghostClass: "ghost"
				},
				drag: false
			};
			return data;
		},
		props: {
			data: Object
		},
		computed: {
			myMap: {
				get: function(){
					return this.data.myMap;
				}
			}
		},
		components: {
			MyObjectIcon,
			MyObjectForm,
			Back,
			draggable
		},
		methods: {
			toggleEditing: function(){
				this.doToggleEditing(!this.editingActive);
			},
			doToggleEditing: function(status){
				this.editingActive = status;
				if (status) {
					if (!this.drawInteraction) {
						this.drawInteraction = new Draw({
							source: this.myMap.myObjectsLayer.getSource(),
							type: "Point",
							stopClick: true // Aktualu identifikavimui...
						});
						this.drawInteraction.on("drawend", function(e){
							e.feature.set("color", this.defaultColor);
							e.feature.setId(this.getFeatureId());
							this.setActiveFeature(e.feature);
							this.doToggleEditing(false);
						}.bind(this));
						this.myMap.map.addInteraction(this.drawInteraction);
					}
				} else {
					this.myMap.map.removeInteraction(this.drawInteraction);
					this.drawInteraction = null;
				}
				this.toggleTooltip(status);
			},
			setFeatures: function(){
				var features = [];
				this.myMap.myObjectsLayer.getSource().forEachFeature(function(feature){
					features.push(feature);
				});
				CommonHelper.sortFeatures(features);
				this.features = features;
			},
			showMainScreen: function(){
				this.activeFeature = null;
			},
			setActiveFeature: function(feature, centerAt){
				this.activeFeature = feature;
				if (centerAt) {
					this.myMap.map.getView().animate({
						center: this.activeFeature.getGeometry().getCoordinates(),
						duration: 500
					});
				}
			},
			doClick: function(e){
				var r;
				if (this.myMap.myObjectsLayer) {
					r = this.myMap.map.forEachFeatureAtPixel(e.pixel, function(feature, layer){
						if (layer == this.myMap.myObjectsLayer) {
							return feature;
						}
					}.bind(this));
					if (r) {
						this.setActiveFeature(r);
					}
				}
				if (!r) {
					this.myMap.doIdentify(e);
				}
			},
			getFeatureTitle: function(feature){
				var title = feature.get("title") || "Objektas be pavadinimo";
				return title;
			},
			removeFeature: function(feature){
				if (this.myMap.myObjectsLayer.getSource().hasFeature(feature)) {
					this.myMap.myObjectsLayer.getSource().removeFeature(feature);
				} else {
					console.warn("WTF? No feature in layer!");
				}
			},
			getFeatureId: function(){
				var id = this.featureId += 1;
				id = Date.now() + id;
				return id;
			},
			setProperIndices: function(){
				this.features.forEach(function(feature){
					feature.setId(this.getFeatureId());
				}.bind(this));
			},
			toggleTooltip: function(status){
				var container = this.myMap.map.getTarget();
				if (status) {
					if (this.tooltip) {
						if (!this.pointerMoveHandler) {
							this.tooltip.setMessage("Spustelkite taškui pridėti");
							this.pointerMoveHandler = this.myMap.map.on("pointermove", this.pointerMove);
						}
						container.addEventListener("mouseenter", this.mouseenterMap);
						container.addEventListener("mouseleave", this.mouseleaveMap);
					}
				} else {
					if (this.tooltip) {
						if (this.pointerMoveHandler) {
							this.tooltip.hide();
							this.myMap.map.un("pointermove", this.pointerMove);
							this.pointerMoveHandler = null;
						}
						container.removeEventListener("mouseenter", this.mouseenterMap);
						container.removeEventListener("mouseleave", this.mouseleaveMap);
					}
				}
			},
			pointerMove: function(e){
				this.tooltip.updatePosition(e);
			},
			mouseenterMap: function(){
				this.tooltip.show();
			},
			mouseleaveMap: function(){
				this.tooltip.hide();
			},
			addTranslateInteraction: function(){
				if (!this.translateInteraction) {
					this.translateInteraction = new Translate({
						layers: [this.myMap.myObjectsLayer],
						filter: function(feature){
							return Boolean(feature.get("active"));
						}.bind(this)
					});
					this.translateInteraction.on("translateend", function(){
						console.log("translateend");
					}.bind(this));
					this.myMap.map.addInteraction(this.translateInteraction);
				}
			}
		},
		created(){
			this.tooltip = this.myMap.$refs.tooltip;
			this.featureId = 0;
			var swatches = CommonHelper.getSwatches();
			this.defaultColor = swatches[0][0];
			if (!this.myMap.myObjectsLayer) {
				this.myMap.myObjectsLayer = new VectorLayer({
					source: new VectorSource(),
					style: CommonHelper.getMyObjectsStyle(),
					zIndex: 1001
				});
				this.myMap.myObjectsLayer.getSource().on("addfeature", this.setFeatures);
				this.myMap.myObjectsLayer.getSource().on("removefeature", this.setFeatures);
				this.myMap.map.addLayer(this.myMap.myObjectsLayer);
				this.addTranslateInteraction();
			}
			if (this.data && this.data.myObjects) {
				var feature,
					features = [];
				this.data.myObjects.forEach(function(featureData){
					feature = new Feature({
						geometry: new Point(featureData.coordinates)
					});
					feature.set("color", featureData.color);
					feature.setId(this.getFeatureId());
					if (featureData.attributes) {
						feature.set("title", featureData.attributes.title);
						feature.set("description", featureData.attributes.description);
					}
					features.push(feature);
				}.bind(this));
				this.myMap.myObjectsLayer.getSource().addFeatures(features);
			}
			this.myMap.identifySuspended = true;
			this.myMap.map.on("click", this.doClick);
		},
		watch: {
			activeFeature: {
				handler: function(newValue, oldValue){
					if (oldValue) {
						oldValue.set("active", false);
					}
					if (newValue) {
						newValue.set("active", true);
						this.step = 1;
					} else {
						this.step = 0;
					}
				}
			}
		}
	}
</script>

<style scoped>
	.editing-active {
		background-color: #e2e2e2;
	}
	.my-object-row {
		cursor: move;
	}
</style>